var $=jQuery;
$(document).ready(function () {

  

  // note
   $('.upsell-list').on('click', '.quick-add__submit', function(e) {
    var allFilled = true;
    $('.upsell-section').find('.gift-message-error-title').remove();
    $('.upsell-list .gift-message-display').each(function() {
      if ($(this).val().trim() === '') {
        allFilled = false;
        return false;
      }
    });

    if (!allFilled) {
      e.preventDefault(); 
      var $error = $('<div class="gift-message-error-title" style="color:red; margin-top:5px; font-size:0.95em;">Bitte gib  eine Nachricht  ein.</div>');
      $('.upsell-section .upsell-title').after($error);
    }
  });

  $('.upsell-list').on('input', '.gift-message-display', function() {
    $('.upsell-section').find('.gift-message-error-title').remove();
  });
 // note

  $('.click_and_collect').on('click', function(e){
    localStorage.setItem('show_home_popup', 'true');
  });

  


  if(localStorage.getItem('show_home_popup') === 'true') {
    $('.home-popup-overlay').css('display', 'flex'); 
    localStorage.removeItem('show_home_popup'); 
  }

  $('.home-popup .close-popup').on('click', function(){
    $('.home-popup-overlay').css('display', 'none');
  });

  $('.home-popup-overlay').on('click', function(e){
    if($(e.target).is('.home-popup-overlay')){
      $(this).css('display', 'none');
    }
  });

  $('.unvergessliche_erlebnisse_sec').each(function () {
    const $section = $(this);
    $section.append(`
      <div class="lightbox-popup" style="display:none;">
        <span class="lightbox-close">&times;</span>
        <img class="lightbox-img" src="" alt="">
      </div>
    `);


    $section.find('.multicolumn-card__image').on('click', function () {
      const src = $(this).attr('src');
      $section.find('.lightbox-img').attr('src', src);
      $section.find('.lightbox-popup').fadeIn(200).css("display", "flex");
    });

  
    $section.find('.lightbox-close').on('click', function () {
      $section.find('.lightbox-popup').fadeOut(200);
    });

 
    $section.find('.lightbox-popup').on('click', function (e) {
      if (e.target === this) {
        $(this).fadeOut(200);
      }
    });
  });
  
    $('#ship-multiple').on('change', function() {
      const $fields = $('#multiple-address-fields');
      if ($(this).is(':checked')) {
        $fields.show();
      } else {
        $fields.hide();
        $fields.find('input').val('');
      }
    }); 
   $('.footer-bottom a:contains("Entwickelt von tzn Digital")').attr({
    target: '_blank',
    rel: 'noopener noreferrer'
  });

  // check cart empty 

   const $cartWrapper = $('cart-items.custom-cart-left');
  const $firstSection = $('.shopify-section:nth-child(1)');

  function toggleCartClass() {
    if ($cartWrapper.hasClass('is-empty')) {
      $firstSection.addClass('no-empty-custom-sec');
    } else {
      $firstSection.removeClass('no-empty-custom-sec');
    }
  }

  const targetNode = document.querySelector('cart-items.custom-cart-left');
  if (targetNode) {
    const observer = new MutationObserver(function(mutationsList) {
      mutationsList.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          toggleCartClass();
        }
      });
    });
    observer.observe(targetNode, { attributes: true });
  }

  $(document).on('click', '.cart-remove-button, .cart-remove-button .button', function() {
    setTimeout(toggleCartClass, 1000);
  });

  document.addEventListener('cart:updated', toggleCartClass);


   // check cart empty 

   $(window).on('load', function() {
    $('.footer-block-link_list_B8QyYj a').attr({
      target: '_blank',
      rel: 'noopener noreferrer'
    });
  });

 $('.unser_partner_sec .button').on('click', function(e) {
  e.preventDefault();
  var $btn = $(this);
  var $rte = $btn.siblings('.rte');

  $rte.toggleClass('active');
  $btn.toggleClass('active');

  if ($btn.hasClass('active')) {
    $btn.text('Weniger lesen');
  } else {
    $btn.text('Mehr lesen');
  }
});
 


   $('.gift-message-display').on('input', function () {
    const productId = $(this).data('product-id');
    const message = $(this).val();
    $('.gift-message-hidden[data-product-id="' + productId + '"]').val(message);
  });
  
   $('#mit_unterbau').on('change', function () {
    if ($(this).is(':checked')) {
      $('.gift_message_wrapper').slideDown();
    } else {
      $('.gift_message_wrapper').slideUp();
    }
  });
  
  $('.shopify-section').each(function () {
  const $section = $(this);
  if ($section.find('.is-empty').hasClass('empty-cart')) {
    $section.addClass('shopify-section-empty');
  } else {
    $section.removeClass('shopify-section-empty');
  }
});
  
$('#kakao-map-alert').on('click', 'path', function (e) {
    const pathId = $(this).attr('id');

    const svg = this.ownerSVGElement;
    const pt = svg.createSVGPoint();
    pt.x = e.clientX;
    pt.y = e.clientY;

    const cursorpt = pt.matrixTransform(svg.getScreenCTM().inverse());


    const bbox = svg.getBBox(); 
    const leftPercent = (cursorpt.x / bbox.width) * 100;
    const topPercent = (cursorpt.y / bbox.height) * 100;

    // alert('Path ID: ' + pathId + '\nLeft: ' + leftPercent.toFixed(2) + '\nTop: ' + topPercent.toFixed(2) + '');
});
  
   $('.product-option dt').on('click', function () {
    $('.product-option').removeClass('open');
    $(this).parent().toggleClass('open');
  });

  $(document).on('click', function (e) {
    
  if (!$(e.target).closest('.product-option').length) {
    $('.product-option').removeClass('open');
  }
  });


//   $('#kakao-map-alert').on('click', 'path', function () {
//   const pathId = $(this).attr('id');
//   alert(pathId);
// });

// Toggle product option
$('.product-option dt').on('click', function () {
  $('.product-option').removeClass('open');
  $(this).parent().toggleClass('open');
});

$(document).on('click', function (e) {
  if (!$(e.target).closest('.product-option').length) {
    $('.product-option').removeClass('open');
  }
});

$('#kakao-map').on('click', 'path.cls-2', function () {
  const pathId = $(this).attr('id');

  $('.kakao-map-label').removeClass('active').fadeOut(150);
  $('.kakao-map-label .label-line').removeClass('active');
  $('.kakao-popup').removeClass('active');
  $('.kakao-popup .popup-content').hide();


  const $currentLabel = $('.kakao-map-label[data-id="' + pathId + '"]');
  if ($currentLabel.length) {
    $currentLabel.addClass('active').fadeIn(200);
    $currentLabel.find('.label-line').addClass('active');
  }

  const $firstDesItem = $currentLabel.find('.des-item').first();
  if ($firstDesItem.length) {
    const popupId = $firstDesItem.data('popup-id');
    const $popup = $('.kakao-popup .popup-content[data-popup-id="' + popupId + '"]');
    if ($popup.length) {
      $('.kakao-popup').addClass('active');
      $popup.fadeIn(200);
    }
  }
});

$('.kakao-map-label').on('click', function (e) {
  if ($(e.target).closest('.des-item').length) return;

  e.stopPropagation();
  const id = $(this).data('id');

  $('.kakao-popup').removeClass('active');
  $('.kakao-popup .popup-content').hide();

  const $firstDesItem = $(this).find('.des-item').first();
  if ($firstDesItem.length) {
    const popupId = $firstDesItem.data('popup-id');
    $('.kakao-popup').addClass('active');
    $('.kakao-popup .popup-content[data-popup-id="' + popupId + '"]').fadeIn(200);
  }
});

$(document).on('click', '.des-item', function (e) {
  e.stopPropagation();
  const popupId = $(this).data('popup-id');

  $('.kakao-popup .popup-content').hide();
  const $popup = $('.kakao-popup .popup-content[data-popup-id="' + popupId + '"]');
  if ($popup.length) {
    $('.kakao-popup').addClass('active').show();
    $popup.fadeIn(200);
  }
});

$(document).on('click', function (e) {
  if (!$(e.target).closest('#kakao-map, .kakao-popup, .kakao-map-label').length) {
    $('.kakao-map-label').removeClass('active').fadeOut(150);
    $('.kakao-map-label .label-line').removeClass('active');
    $('.kakao-popup').removeClass('active');
    $('.kakao-popup .popup-content').hide();
  }
});

  $('.kakao-menu-link').each(function () {
    const id = $(this).data('id');
    const $path = $('#' + id);
    if ($path.length) {
      $path.addClass('cls-2');   
      $path.css('fill', '#523500');
    }
  });

  $(document).on('click', '.popup-close', function(e) {
    e.stopPropagation(); 
    $('.kakao-popup').removeClass('active');
    $('.kakao-popup .popup-content').fadeOut(200);
  });
  // debug test

   const params = new URLSearchParams(window.location.search);
  const isDebug = params.get('debug') === 'true';

  if (isDebug) {
  const infoDiv = $('#kakao-map-info');

  $('#kakao-map').on('click', 'path', function (e) {
    const pathId = $(this).attr('id');

    const svg = this.ownerSVGElement;
    const pt = svg.createSVGPoint();
    pt.x = e.clientX;
    pt.y = e.clientY;

    const cursorpt = pt.matrixTransform(svg.getScreenCTM().inverse());
    const bbox = svg.getBBox(); 
    const leftPercent = (cursorpt.x / bbox.width) * 100;
    const topPercent = (cursorpt.y / bbox.height) * 100;

    const textToCopy = 
      'Path ID: ' + pathId + 
      ' -  Left: ' + leftPercent.toFixed(2) + 
      ' -  Top: ' + topPercent.toFixed(2);

    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        infoDiv.text(textToCopy);
        // alert('Copied & Info:\n' + textToCopy);
      })
      .catch(err => console.error('Failed to copy:', err));
  });
}





  var $timelineSection = $('.timeline-section');
  if ($timelineSection.length) {
    var $contentSlider = $timelineSection.find('.timeline-slider_content').flickity({
      asNavFor: '.timeline-section .timeline-slider_thumb',
      prevNextButtons: false,
      fade: true,
      freeScroll: false,
      pageDots: false
    });

    var $thumbSlider = $timelineSection.find('.timeline-slider_thumb').flickity({
      freeScroll: false,
      prevNextButtons: true,
      wrapAround: true,
      pageDots: false
    });

    function updatePrevNext() {
      var flkty = $thumbSlider.data('flickity');
      if (!flkty) return;

      var $cells = $(flkty.getCellElements());
      var index = flkty.selectedIndex;

      $cells.removeClass('is-prev is-next');

      var prevIndex = (index - 1 + $cells.length) % $cells.length;
      var nextIndex = (index + 1) % $cells.length;

      $cells.eq(prevIndex).addClass('is-prev');
      $cells.eq(nextIndex).addClass('is-next');
    }

    $thumbSlider.on('select.flickity', updatePrevNext);
    updatePrevNext();
  }
  

//*** MAP */



function updateLabelLine($label) {
    const $box  = $label;              
    const $line = $label.find('.label-line');

    if (!$box.length || !$line.length) return;

    // Extra length added to the line (you can change this)
    const LINE_EXTRA = 80; // <--- Increase this to make lines longer

    const padding = 0;
    const gap = 0;

    const w = $box.outerWidth() - padding * 2;
    const h = $box.outerHeight() - padding * 2;

    // Add extra length to line (horizontal or vertical)
    const lineW = w + LINE_EXTRA;
    const lineH = h + LINE_EXTRA;

    const originalLeft = parseFloat($label.data("left"));
    const originalTop  = parseFloat($label.data("top"));

    // reset line
    $line.css({
        width: "",
        height: "",
        top: "",
        left: "",
        right: "",
        bottom: "",
        transform: "",
        position: "absolute"
    });

    // text independent
    const $text = $label.find(".label-content");
    $text.css({
        top: "",
        left: "",
        right: "",
        bottom: "",
        transform: ""
    });

    // ---------------- TOP ----------------
    if ($label.hasClass("position-Top")) {
        const e = LINE_EXTRA;

        $line.css({
            height: lineH + "px",    // <--- extended line
            width: "1px",
            top: h - e + "px",
            left: "50%",
            transform: "translateX(-50%)"
        });

        $label.css({
            top: `calc(${originalTop}% - ${h}px)`
        });

        $text.css({
            bottom: (h + 20) + "px",
            left: "50%",
            transform: "translateX(-50%)"
        });
    }

    // ---------------- BOTTOM ----------------
    if ($label.hasClass("position-Bottom")) {
         const e = LINE_EXTRA;
        $line.css({
            height: lineH + "px",   // <--- extended
            width: "1px",
            bottom: (h- e) + "px",
            left: "50%",
            transform: "translateX(-50%)"
        });

        $label.css({
            top: `calc(${originalTop}% + ${h}px)`
        });

        $text.css({
            top: -(h-e) + "px",
            right: "-60%"
        });
    }

    // ---------------- LEFT ----------------
    if ($label.hasClass("position-Left")) {
          const e = LINE_EXTRA;  // e = extra offset


        $line.css({
            width: lineW + "px",    // <--- extended
            height: "1px",
            left: (w - e) + "px",    
            top: "50%",
            transform: "translateY(-50%)"
        });

        $label.css({
            left: `calc(${originalLeft}% - ${w}px)`
        });

        $text.css({
            right: -(w- e) + "px",
            top: "50%",
            transform: "translateY(-50%)"
        });
    }

    // ---------------- RIGHT ----------------
    if ($label.hasClass("position-Right")) {
       const e = LINE_EXTRA;
        $line.css({
            width: lineW + "px",    // <--- extended
            height: "1px",
            right: (w - e) + "px",
            top: "50%",
            transform: "translateY(-50%)"
        });

        $label.css({
            left: `calc(${originalLeft}% + ${w}px)`
        });

        $text.css({
            left: -(w - e) + "px",
            top: "50%",
           	transform: "translateY(-50%)"
        });
    }
}

function updateAllLines() {
    $(".kakao-map-label").each(function () {
        updateLabelLine($(this));
    });
}

$(window).on("load resize", updateAllLines);




  // $('.acc-head').on('click', function() {
  //     if($(this).hasClass('active')) {
  //       $(this).siblings('.acc-content').slideUp();
  //       $(this).removeClass('active');
  //     }
  //     else {
  //       $('.acc-content').slideUp();
  //       $('.acc-head').removeClass('active');
  //       $(this).siblings('.acc-content').slideToggle();
  //       $(this).toggleClass('active');
  //     }
  // });
  
    $(document).on('click', '[data-type="increase-qty"]', function () {
      var input = $(this).closest('[data-card-qty-wrapper]').find('[data-card-qty-input]');
      var currentVal = parseInt(input.val()) || 0;
      input.val(currentVal + 1).change();
    });

    $(document).on('click', '.has-dropdown .footer-block__heading,.kakao-list-sidebar-inner .p-h6', function () {
      $(this).toggleClass('active');
    });
     $(document).on('click', '.acc_tab-inner .subtitle > p', function () {
      $('.dropdown-faq-menu').toggleClass('active');
    });
    $(document).on('click', '.bottom_details h2', function () {
      $(this).toggleClass('active');
    });
    $(document).on('click', '[data-type="decrease-qty"]', function () {
      var input = $(this).closest('[data-card-qty-wrapper]').find('[data-card-qty-input]');
      var currentVal = parseInt(input.val()) || 0;
      if (currentVal > 1) {
        input.val(currentVal - 1).change();
      }
    });
  const currentUrl = window.location.pathname + window.location.search;

  $(".filter-option").each(function () {
    const optionUrl = $(this).data("url");
    if (optionUrl === currentUrl) {
      $(this).addClass("active");
    }
  });

 if ($('.product__media-list li').length >= 2) {
    $('.product__media-list').flickity({
      pageDots: true,
      freeScroll: false,
      wrapAround: true,
      prevNextButtons: true,
      autoPlay: false,
      groupCells: false,
      cellAlign: 'center',
    });
  }

});

///// Tab Faq
  // $(document).on('click','.acctab_title', function(e){
  //    if($(window).width() >= 768){
  //       $('.acctab_title').removeClass('active-accor');
  //       $(this).addClass('active-accor');
  //       $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
  //       $($(this).attr('data-act-title')).addClass('activemain-tab').show();
  //    }else{
  //      $('.acctab_title').removeClass('active-accor');
  //       $(this).addClass('active-accor');
  //       $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
  //       $($(this).attr('data-act-title')).addClass('activemain-tab').show();
  //       // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
  //       $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
  //       $($(this).attr('data-act-title')).addClass('activemain-tab').show();
  //    }
  // });
  // $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
  //     $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
  // });
  $('.acctab_title').on('click', function() {
      $('.acctab_title').removeClass('active-accor');
      $(this).addClass('active-accor');
      
      $('.tabs-content').hide().removeClass('activemain-tab');
      
      var target = $(this).data('act-title');
      
      $(target).show().addClass('activemain-tab');
      
      $('html, body').animate({
          scrollTop: $(target).offset().top - 200 
      }, 800); 
  });
   $(window).on('scroll', function() {
        $('.tabs-content').each(function() {
            var $this = $(this);
            var topOfElement = $this.offset().top - 250; 
            var bottomOfElement = topOfElement + $this.outerHeight();
            var scrollTop = $(window).scrollTop();

            if (scrollTop >= topOfElement && scrollTop <= bottomOfElement) {
                var currentId = $this.attr('id');
                
                $('.acctab_title').removeClass('active-accor');
                
                $('.acctab_title[data-act-title="#' + currentId + '"]').addClass('active-accor');
                
                $('.tabs-content').hide().removeClass('activemain-tab');
                $this.show().addClass('activemain-tab');
            }
        });
    });
  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
  });
  ///// Tab Faq

//load more product
   document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.querySelector('[data-pagination-btn]');
    const productGrid = document.getElementById('product-grid');
    
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function(e) {
            e.preventDefault();
            const nextUrl = loadMoreButton.getAttribute('href');
            
            loadMoreButton.textContent = "Laden...";
            loadMoreButton.setAttribute('disabled', 'true');
            
            fetch(nextUrl)
                .then(response => response.text())
                .then(data => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
                    
                    const newProducts = tempDiv.querySelector('#product-grid').innerHTML;
                    
                    productGrid.innerHTML += newProducts;
                    
                    // var sliderProducts = document.querySelectorAll('.has-slider-wrapper');

                    // sliderProducts.forEach(function(slider) {
                    //     new Flickity(slider, {
                    //         pageDots: false,
                    //         freeScroll: false,
                    //         wrapAround: true,
                    //         prevNextButtons: true,
                    //         autoPlay: false,
                    //         groupCells: false,
                    //         cellAlign: 'center',
                    //     });
                    // });
                    
                    const newButton = tempDiv.querySelector('[data-pagination-btn]');
                    if (newButton) {
                        loadMoreButton.setAttribute('href', newButton.getAttribute('href'));
                        loadMoreButton.textContent = "MEHR ANZEIGEN";
                        loadMoreButton.removeAttribute('disabled');
                    } else {
                        loadMoreButton.textContent = "Keine Produkte mehr";
                    }
                })
                .catch(error => {
                    console.error('Error loading more products:', error);
                    loadMoreButton.textContent = "Try again";
                    loadMoreButton.removeAttribute('disabled');
                });
        });
    }
  });

  function initFlickity_mobile() {
    $(window).on('scroll resize', function() {
        if ($(window).width() <= 990) {
          var footerTop = $('footer').offset().top;
          var windowBottom = $(window).scrollTop() + $(window).height();

          if (windowBottom >= footerTop - 50) {
            $('.cart__ctas').fadeOut();
          } else {
            $('.cart__ctas').fadeIn();
          }
        } else {
          $('.cart__ctas').show();
        }
      });


  if ($(window).width() < 990) {
    $('.trust_icon_sec .static-items, .two-column-banner, .firmengeschenkservice-col .multicolumn-list,.unvergessliche_erlebnisse_sec ul')
      .not('.flickity-enabled') 
      .flickity({
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        percentPosition: true,
        prevNextButtons: false,
      });
      $('.collection-list-wrapper .collection-list')
      .not('.flickity-enabled') 
      .flickity({
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        percentPosition: true,
        prevNextButtons: true,
      });
  } else {
    $('.trust_icon_sec .static-items.flickity-enabled, .two-column-banner.flickity-enabled, .firmengeschenkservice-col .multicolumn-list.flickity-enabled')
      .flickity('destroy');
  }
}

$(document).ready(function () {
  initFlickity_mobile();
});

$(window).on('resize', function () {
  initFlickity_mobile();
});



// const scriptTag = $('script[data-selected-variant]').first();  
//   if (scriptTag.length) {
//     console.log(scriptTag);
//       const jsonData = JSON.parse(scriptTag.text().trim());
//       const featuredMediaId = jsonData.featured_media?.id;  
//       const sectionIdValue = $('input[name="section-id"]').val();
//       const mediaId = `${sectionIdValue}-${featuredMediaId}`;
    
//    setTimeout(() => {
//     var $thumb = $(`li[data-att="${mediaId}"]`);
//     console.log('FOUND?', $thumb.length, mediaId);
//     if ($thumb.length) $thumb.trigger('click');
//   }, 500);
//   }


const scriptTag = $('script[data-selected-variant]').first();  
  if (scriptTag.length) {
    console.log(scriptTag);
      const jsonData = JSON.parse(scriptTag.text().trim());
      const featuredMediaId = jsonData.featured_media?.id;  
      const sectionIdValue = $('input[name="section-id"]').val();
      const mediaId = `${sectionIdValue}-${featuredMediaId}`;
    
   setTimeout(() => {
    var $thumb = $(`li[data-att="${mediaId}"]`);
    console.log('FOUND?', $thumb.length, mediaId);
    if ($thumb.length) $thumb.trigger('click');
  }, 500);
  }
